import { Text } from '@avanta/shared/components/Text';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { Info } from 'lucide-react';
import { Trans, useTranslation } from 'react-i18next';

export const ReopenRecordBanner = (): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  return (
    <div role="status" className="col-span-2 flex items-start gap-4 rounded-xl bg-plum-100 p-4">
      <Info aria-hidden className="size-6 shrink-0 text-teal-600" strokeWidth={1.25} />
      <div className="flex min-w-0 flex-col gap-1">
        <Text variant="text-sm-medium" className="text-denim-500">
          {t('AppointmentsReserve.ReopenRecordBanner.title')}
        </Text>
        <Text variant="text-sm-regular" className="text-gray-500">
          <Trans
            i18nKey="AppointmentsReserve.ReopenRecordBanner.description"
            ns={LOCIZE_NS.INSURANCE}
          />
        </Text>
      </div>
    </div>
  );
};
